import * as React from 'react';
import { AuthLink } from '@/features/auth/components/AuthLink';

interface AuthLinkWrapperProps {
  isRegister: boolean;
  onSwitch: () => void;
  isLoading: boolean;
}

/** Text link that toggles between login and register views. */
export const AuthLinkWrapper: React.FC<AuthLinkWrapperProps> = ({
  isRegister,
  onSwitch,
  isLoading,
}) => (
  <div className='flex h-[44px] items-center justify-center text-center'>
    <AuthLink
      text={isRegister ? 'Already have an account?' : "Don't have an account?"}
      actionText={isRegister ? 'Sign in' : 'Create Account'}
      onClick={onSwitch}
      disabled={!!isLoading}
      variant='light'
    />
  </div>
);
